export function getShortIsoDate(date) {
    return date.toISOString().substr(0, 10);
}

export function getDate(date) {
    return new Date(date).toLocaleDateString('de-CH');
}

export function getLongIsoDate(date) {
    if(date instanceof String)
        return date + "T00:00:00";
    else if(date instanceof Date)
        return getShortIsoDate(date) + "T00:00:00";
}